import { render } from "./PositionView.vue?vue&type=template&id=ca071200&scoped=true"
import script from "./PositionView.vue?vue&type=script&lang=js"
export * from "./PositionView.vue?vue&type=script&lang=js"

import "./PositionView.vue?vue&type=style&index=0&id=ca071200&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca071200"]])

export default __exports__